import WelcomePage from "./Containers/WelcomePage";
import React from "react";
import "./App.css";

const MainContainer = () => {
  return <WelcomePage />;
};

export default MainContainer;
